export const ATTACHMENTS_LIST_VARIANTS = {
  GRID: 'grid',
  LIST: 'list',
} as const;

export const VIEWER_TYPES = {
  INTERNAL: 'internal',
  EXTERNAL: 'external',
} as const;

export const UPLOAD_METHODS = {
  PASTE: 'paste',
  DRAG: 'drag',
  BROWSE: 'browse',
} as const;

export const DOWNLOAD_METHODS = {
  DEFAULT: 'default',
  VIEWER: 'viewer',
  CLICK: 'click',
};

export type UploadMethod = (typeof UPLOAD_METHODS)[keyof typeof UPLOAD_METHODS];
export type DownloadMethod =
  (typeof DOWNLOAD_METHODS)[keyof typeof DOWNLOAD_METHODS];
